import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

interface Props {
  id: string;
  value: boolean;
  label: string;
  onClick: () => void;
}

const Checkbox: FunctionComponent<Props> = ({ id, label, value, onClick }) => {
  const checkboxClassNames = classNames({
    form__checkbox: true,
    active: value,
  });

  return (
    <div className="form__row" onClick={onClick} id={id}>
      <div className={checkboxClassNames}>
        {label}
        {value}
      </div>
    </div>
  );
};

export default Checkbox;
